module.exports = __webpack_public_path__ + "static/media/ppt.e35c16f9.svg";